const config = {
  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_URL || '/api',
  

  // Authentication
  AUTH_ENDPOINTS: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    REFRESH: '/auth/refresh',
    LOGOUT: '/auth/logout',
  },
  
  // API Endpoints
  API_ENDPOINTS: {
    SHOPS: '/shops',
    PRODUCTS: '/products',
    ALLEGRO: '/allegro',
    CUSTOMERS: '/customers',
  },
  
  // Token storage keys
  STORAGE_KEYS: {
    ACCESS_TOKEN: 'accessToken',
    REFRESH_TOKEN: 'refreshToken',
  },
  
  // App configuration
  APP_NAME: 'Allegro Integrator',

  // Development settings
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  
  // Performance settings
  PERFORMANCE: {
    DEFAULT_PAGE_SIZE: 50,
    MAX_PAGE_SIZE: 200,
    DEBOUNCE_DELAY: 300, // ms
    CACHE_DURATION: 5 * 60 * 1000, // 5 minutes
    VIRTUALIZATION_THRESHOLD: 100, // Enable virtualization for tables with more than 100 items
  },
  
  // Pagination settings
  PAGINATION: {
    DEFAULT_PAGE: 1,
    DEFAULT_LIMIT: 50,
    MAX_LIMIT: 200,
  },
};

export default config; 